package org.hs_soft.runmynesto.domain.usecase.home

import org.hs_soft.runmynesto.domain.repository.network_datasource.options.operation.SaveLanguageRepository

class SaveLanguageUseCase(
    private val repository: SaveLanguageRepository
) {
    suspend operator fun invoke(lang:String) {
        return repository.saveLanguage(lang)
    }
}